/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-13 09:24:52
 * @LastEditors: sj
 * @LastEditTime: 2022-01-18 09:50:20
 */

import { ADMIN_API_PREFIX } from './constant'
import { Request } from './request'

export interface ReplaceMakeOrganizationParams {
  size?: number
  current?: number
  name?: string
  area?: string
  cityCode?: string
  countyCode?: string
  provinceCode?: string
}
//  代煎机构列表
export const ReplaceMakeOrganizationList = (
  params: ReplaceMakeOrganizationParams
): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionBinding/list`,
    method: 'GET',
    params,
  }
}
export interface OrganizationPartnerNameParams {
  size?: number
  current?: number
  tenantIds?: string
  keyWord?: string
}
// 获取代煎机构的合作供应商名字
export const OrganizationPartnerName = (
  params: OrganizationPartnerNameParams
): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/potionTenantSupplierList`,
    method: 'GET',
    params,
  }
}

// 获取合作供应商列表
export interface OrganizationPartnerListParams {
  tenantIds?: string
  supplierId?: string
  keyWord?: string
  size?: number
  current?: number
}

export const OrganizationPartnerList = (
  params: OrganizationPartnerListParams
): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/tenantSupplierList`,
    method: 'GET',
    params,
  }
}

export interface changeOrganizationStatusParams {
  openType: number
  tenantId: string
}
// 代煎状态切换
export const changeOrganizationStatus = (
  body: changeOrganizationStatusParams
): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionBinding/updateOpenStatus`,
    method: 'POST',
    body,
  }
}
